/**
 * Legacy colors, pre-KM. Once all pages are on KM, we should not have any
 * usages left, and can remove them.
 */ export var legacyColors = {
    border: "#dedfe0",
    kaggle: {
        gray: "#a9a9a9",
        blueLightest: "#e1f0f6",
        blueDark: "#008abc",
        blueDarkest: "#006184",
        red: "#cc615c",
        black: "#47494D",
        green: "#69AC35",
        orange: "#F69732"
    },
    content: {
        borderLight: "#ebecec",
        border: "rgb(222, 223, 224)"
    },
    text: {
        medium: "rgba(0,0,0,0.7)",
        light: "rgba(0,0,0,0.4)",
        link: "#008ABC",
        100: "rgba(0,0,0,1)",
        70: "rgba(0,0,0,0.7)",
        50: "rgba(0,0,0,0.5)",
        40: "rgba(0,0,0,0.4)"
    },
    textReverse: {
        70: "rgba(255,255,255,0.7)"
    },
    hover: {
        light: "rgba(0,0,0,0.03)"
    },
    misc: {
        grayLighter: "#C4C9CD",
        grayLightest: "#F0F0F0"
    },
    anchor: {
        base: "#008ABC"
    },
    /**
   * From legacy 'material.color.brand', which do not line up to KM colors.
   * See http://shortn/_ACMLW8m46f for gray comparisons to KM grays.
   */ brand: {
        blue: {
            900: "#007BA8",
            800: "#008ABC",
            700: "#04A4DE",
            600: "#0CB1ED",
            400: "#79D9FF",
            300: "#A5E5FF",
            200: "#D2F2FF",
            100: "#E8F8FF",
            50: "#F6FDFF"
        },
        grey: {
            900: "#47494D",
            800: "#595B5E",
            700: "#6C6D71",
            600: "#7E7F82",
            500: "#919294",
            400: "#B5B6B8",
            300: "#C7C8C9",
            200: "#DEDFE0",
            100: "#ECECED",
            50: "#F8F8F8"
        }
    }
};
